import { InfoAlert } from '@repo/ui'
import { useTranslation } from 'react-i18next'
import useOnlineDetection from '@/features/offline/hooks/useOnlineDetection'

export interface OfflineAlertProps {
  'data-testid': string
}

export default function OfflineAlert({
  'data-testid': testId
}: Readonly<OfflineAlertProps>) {
  const { t } = useTranslation('common')
  const isOnline = useOnlineDetection()

  if (isOnline) {
    return null
  }

  return <InfoAlert data-testid={testId}>{t('offline.info')}</InfoAlert>
}
